import { render, staticRenderFns } from "./EditTrainingSchedule.vue?vue&type=template&id=397ba317&scoped=true&"
import script from "./EditTrainingSchedule.vue?vue&type=script&lang=js&"
export * from "./EditTrainingSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397ba317",
  null
  
)

export default component.exports